import { StepProgressBar } from './step-progress-bar';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { StepProgressBarProperties } from './step-progress-bar-types';
import StepProgressBarAPI from './step-progress-bar-api';
const awesomeProperties = {
    api: StepProgressBarAPI,
    name: 'StepProgressBar',
    properties: StepProgressBarProperties,
    type: ComponentType.DATA_DISPLAY
};
AwesomeComponent(awesomeProperties)(StepProgressBar);
export * from './step-progress-bar-types.js';
export { StepProgressBar, StepProgressBarAPI, };
//# sourceMappingURL=index.js.map